import {RawRumData} from "../utils/util";
import {trackingEndpointLogic} from "../tracking/tracking";
import {getPagecluster} from "@otto-ec/global-resources/misc";
import * as device from "@otto-ec/global-resources/device";


export const getTsSfid = (
    tsSfidElement = document.querySelector(".ts-bct")
): string => tsSfidElement?.getAttribute("data-ts_sfid") ?? "";

const collectRumOnLoad = async () => {
    const navigationTiming = performance.getEntriesByType("navigation")[0];

    const rawRumData: RawRumData = {
        deviceBrowser: device.browser,
        deviceOS: device.os,
        pagecluster: getPagecluster() ?? "unknown",
        rum_deviceType: device.type,
        rum_domComplete: Math.floor(navigationTiming.domComplete),
        rum_sfid: getTsSfid(),
        rum_supportsTouch: (await device.getPointerType()).isTouchable,
        url: window.location.href,
    };

    trackingEndpointLogic(rawRumData);
};
/**
 *
 */
export const initRumCollection = () => {
    window.addEventListener("load", collectRumOnLoad, {once: true});
};
